import { Outlet } from 'react-router';
import { Sidebar } from './Sidebar';
import styles from '@/styles/components/AppShell/style.scss';

export function AppShell() {
  return (
    <div className={styles.shell}>
      <Sidebar />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
